
import { withRouter } from 'react-router-dom';
import React from 'react';
import { inject, observer } from 'mobx-react';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import Paper from '@material-ui/core/Paper';
import Images from '../../Theme/Images';
import { withStyles } from '@material-ui/core/styles';
import { dashboardStyles } from '../../Styles/dashboardStyles';
import { ReactSVG } from 'react-svg';
import { NavLink } from 'react-router-dom';
import Typography from '@material-ui/core/Typography';
import DocPreview from './DocPreview';
import Loader from 'react-loader-spinner'
import Moment from 'moment';
import DeleteForeverIcon from '@material-ui/icons/DeleteForever';
import ShareIcon from '@material-ui/icons/Share';
import GetAppIcon from '@material-ui/icons/GetApp';
import Checkbox from '@material-ui/core/Checkbox';
import Header from '../../Common/Header'
import FileAssignment from './FileAssignment';
import FileActionSnackbar from './FileActionSnackbar';
import DeleteDialog from './DeleteDialog';
import ChevronLeftIcon from '@material-ui/icons/ChevronLeft';
import ChevronRightIcon from '@material-ui/icons/ChevronRight';
import MenuItem from '@material-ui/core/MenuItem';
import MoreVertIcon from '@material-ui/icons/MoreVert';
import Menu from '@material-ui/core/Menu';
import Tooltip from '@material-ui/core/Tooltip';
import { Scrollbars } from 'react-custom-scrollbars';


const LightTooltip = withStyles((theme) => ({
    tooltip: {
        backgroundColor: theme.palette.white,
        color: 'rgba(0, 0, 0, 0.87)',
        boxShadow: theme.shadows[1],
        fontSize: '13px',
    },
}))(Tooltip);
@inject('documentStore', 'commonStore', 'userStore', 'dashboardStore')
@observer
class DocumentList extends React.Component {
    state = {
        heading: '',
        showPreview: false,
        currentDoc: {},
        searchText: '',
        hideStatus: false,
        noDocMessage: '',
        selectAll: false,
        openDeleteDialog: false,
        docToDelete: {},
        pagination: {
            low: 0,
            high: 10,
            page: 0
        },
        timeField: 'createdAt',
    }

    componentDidMount() {
        let { filter, active } = this.props;
        this.props.dashboardStore.resetSearch();
        let { user, isLocalTemplatePresent } = this.props.userStore;
        this.interval = setInterval(() => this.setState(this.fetchDataInIntervals()), 15000);
        console.log(filter, 'filter')
        if (filter === 'AI_PENDING')
            this.setState({
                hideStatus: true,
                noDocMessage: 'All documents moved to drafts'
            })
        else if (filter !== 'REVIEW_PENDING' && filter !== 'AI_PENDING')
            this.setState({
                hideStatus: true,
                noDocMessage: 'No documents found!'
            })
        else if (filter === 'REVIEW_PENDING' && !isLocalTemplatePresent) {
            this.setState({
                noDocMessage: 'Please setup a template to begin!'
            })
        }
        else {
            if (user.userType === 'AGENT')
                this.setState({ noDocMessage: 'No documents assigned!' })
            else
                this.setState({ noDocMessage: 'No documents found! Click on Import to begin.' })
        }
        this.props.commonStore.setActiveTab(active);
        this.props.dashboardStore.setPageNumber(0);
        if (filter === "REVIEW_PENDING" || filter === "AI_PENDING") {
            this.props.dashboardStore.sortDocumentList(this.props.filter, 'createdAt', -1)
            if (user.userType === 'AGENT')
                this.setState({ timeField: 'assignedAt' })
            else
                this.setState({ timeField: 'createdAt' })
        }
        else if (filter === "REVIEW_COMPLETE") {
            this.props.dashboardStore.sortDocumentList(this.props.filter, 'reviewedAt', -1)
            this.setState({ timeField: 'reviewedAt' })
        }
        else {
            this.props.dashboardStore.sortDocumentList(this.props.filter, 'exportedAt', -1)
            this.setState({ timeField: 'exportedAt' })
        }


    }

    fetchDataInIntervals = () => {
        let { filter } = this.props;
        let { user } = this.props.userStore;
        //if (this.props.dashboardStore.processingStatus && this.props.dashboardStore.processingStatus.processing > 0) {
        this.props.dashboardStore.getPeriodicDocList(filter);
        // }
    }

    componentWillUnmount() {
        clearInterval(this.interval);
    }

    onDelete = (doc) => {
        this.setState({ openDeleteDialog: true, docToDelete: doc });
        this.handleCloseMenu()
    }

    confirmDelete = () => {
        let temp = []
        temp.push(this.state.docToDelete._id)
        this.props.dashboardStore.deleteDocument(temp, this.props.filter)
    }
    cancelDelete = () => {
        this.setState({ openDeleteDialog: false, docToDelete: {} })
    }

    onMouseEnter(item) {
        if (item.aiErrorFlag)
            console.log('Error while processing')
        else
            this.setState({ showPreview: true, currentDoc: item })
    }

    onMouseLeave() {
        this.setState({ showPreview: false })
    }

    searchDocuments = (event) => {
        const { searchText } = this.state;
        let docStatus = this.props.filter;
        if (event.which === 13) {
            if (this.state.searchText.replace(/\s/g, "").length >= 3)
                this.props.dashboardStore.searchDocuments(this.state.searchText, docStatus)
            else
                this.props.commonStore.handleOpenSnackBar("Enter atleast three characters to search!", "info")
        }
    }

    downloadDoc = (docId) => {
        let temp = [];
        temp.push(docId)
        this.props.dashboardStore.downloadOriginalDoc(temp);
        this.handleCloseMenu()
    }

    resetSelectAll = () => {
        this.setState({ selectAll: false })
    }

    onChangeSelectAll = (e, v) => {
        this.props.dashboardStore.handleSelectAll(v)
    }

    onCheckboxChange = (event, index, value) => {
        if (!value)
            this.setState({
                selectAll: false
            })
        this.props.dashboardStore.setSelectedDocs(index, value)
    }

    getDocumentIcon = (doc) => {
        let temp = 'png'
        if (doc.originalFileName.toLowerCase().endsWith('.pdf'))
            temp = 'pdf'
        //  if (doc.docStatus == 'AI_PENDING' || !doc.templateMappingFlag)
        if (doc.docStatus == 'AI_PENDING')
            temp += 'Inactive'
        return Images[`${temp}`]
    }

    assignDocuments = (id) => {
        this.props.userStore.openDialog()
        this.props.dashboardStore.openFileAssign(id);
        this.handleCloseMenu()
    }

    sortList = (sortType, index, field) => {
        this.props.dashboardStore.sortDocumentList(this.props.filter, field, sortType)
    }

    modifyText = (text) => {
        let temp = []
        text.split("_").length && text.split("_").forEach(word => {
            word = word.charAt(0).toUpperCase() + word.slice(1).toLowerCase();
            temp.push(word)
        })
        return temp.join(" ")
    }

    renderNotFoundMessage = (message) => {
        const { classes } = this.props;
        return (
            <div className={classes.noDocMessage}>
                <span style={{ display: 'table-cell', verticalAlign: 'middle' }} className={classes.docHeader}>{message}</span>
            </div>
        )
    }

    renderPagination = () => {
        const { countData, totalDocs } = this.props.dashboardStore;
        const { pagination } = this.state;
        const { classes, filter } = this.props;
        let count = totalDocs
        let temp = pagination.high;
        if (count <= temp)
            temp = count
        return (
            <div className={classes.pagination}> {pagination.low + 1}-{temp} of {count}
                <ChevronLeftIcon className={classes.optionIcons} onClick={(e) => this.getPage('prev')} />
                <ChevronRightIcon className={classes.optionIcons} onClick={(e) => this.getPage('next')} />
            </div>
        )
    }

    handleCloseMenu = () => {
        this.props.dashboardStore.resetMenuArray()
    }

    renderMenu = (index, row) => {
        const { menuArray } = this.props.dashboardStore;
        const { classes } = this.props
        const { user } = this.props.userStore;
        return (
            <React.Fragment>
                <MoreVertIcon className={classes.optionIcons} onClick={(e) => this.props.dashboardStore.openMenu(e, index)} />
                <Menu
                    elevation={1}
                    id="simple-menu"
                    anchorEl={menuArray[index]}
                    keepMounted
                    open={Boolean(menuArray[index])}
                    onClose={(event) => { this.handleCloseMenu() }}
                    classes={{
                        list: classes.menuItems
                    }}
                >
                    {user.userType !== 'AGENT' ? <MenuItem onClick={(event) => this.onDelete(row)} >Delete</MenuItem> : null}
                    <MenuItem onClick={(event) => this.downloadDoc(row._id)}>Download</MenuItem>
                    {this.props.filter === "REVIEW_PENDING" && user.userType !== "AGENT" ? <MenuItem onClick={(e) => this.assignDocuments(row._id)}>Assign to</MenuItem> : null}
                </Menu>
            </React.Fragment>
        )
    }

    getPage = (type) => {
        const { pagination } = this.state;
        const { countData } = this.props.dashboardStore;
        const { filter } = this.props;
        const { user } = this.props.userStore;
        let count = 0
        if (user.userType === 'SUPER_ADMIN')
            count = countData[`${this.props.filter}`]
        else
            count = filter === "REVIEW_PENDING" ? countData[`${this.props.filter}`] + countData['AI_PENDING'] : countData[`${this.props.filter}`]

        if (type === 'prev' && pagination.page - 1 > -1) {
            const temp = Object.assign({}, pagination, {
                low: pagination.low - 10,
                high: pagination.high - 10,
                page: pagination.page - 1
            });
            this.props.dashboardStore.setPageNumber(temp.page);
            if (user.userType === 'SUPER_ADMIN')
                this.props.dashboardStore.getGlobalDocumentList(filter)
            else
                this.props.dashboardStore.fetchDocumentList(this.props.filter)
            this.setState({ pagination: temp })
        }
        else if (type === 'next' && !(Math.ceil(count / 10) * 10 == pagination.high)) {
            const temp = Object.assign({}, pagination, {
                low: pagination.low + 10,
                high: pagination.high + 10,
                page: pagination.page + 1
            });
            this.props.dashboardStore.setPageNumber(temp.page);
            if (user.userType === 'SUPER_ADMIN')
                this.props.dashboardStore.getGlobalDocumentList(filter)
            else
                this.props.dashboardStore.fetchDocumentList(this.props.filter)
            this.setState({ pagination: temp })
        }


    }

    renderSupportingComponents = () => {
        const { filter, active } = this.props;
        const { showPreview } = this.state;
        const { currentDoc } = this.state
        return (
            <React.Fragment>
                <FileActionSnackbar filter={filter} resetSelectAll={this.resetSelectAll} activeTab={active}></FileActionSnackbar>
                <FileAssignment></FileAssignment>
                <DocPreview showPreview={showPreview} currentDoc={currentDoc}></DocPreview>
                <DeleteDialog open={this.state.openDeleteDialog} cancelDelete={this.cancelDelete} delete={this.confirmDelete}></DeleteDialog>
            </React.Fragment>
        )
    }

    renderTableHead = () => {
        const classes = this.props.classes;
        const { hideStatus, selectAll } = this.state;
        const { activeTab } = this.props.commonStore;
        const { user } = this.props.userStore
        const { selectAllDocs, tableHeader } = this.props.dashboardStore
        return (
            <TableHead>
                <TableRow >
                    <TableCell padding="checkbox" className={classes.checkbox}>
                        <Checkbox className={classes.checkbox}
                            checked={selectAllDocs}
                            onChange={(event, value) => this.onChangeSelectAll(event, value)}
                            color="primary"
                            inputProps={{ classes: { root: classes.checkbox } }} />
                    </TableCell>
                    {
                        tableHeader.map((row, index) => (
                            (
                                row['category'].indexOf(activeTab) >= 0 && row['userType'].indexOf(user.userType) >= 0 ?
                                    (
                                        <TableCell key={'header' + index} className={classes.tableHeader} style={{ width: this.props.filter === "REVIEW_PENDING" ? row.width : 'auto' }} align="left">
                                            <div style={{ display: 'flex' }}>
                                                {row.name}
                                                {row.allowSort ? (row.sort === 1 ?
                                                    <ReactSVG className={classes.sortIcons} src={Images.sort} onClick={(e) => this.sortList(-1, index, row.type)} /> :
                                                    <ReactSVG className={classes.sortIcons} src={Images.reverseSort} onClick={(e) => this.sortList(1, index, row.type)} />)

                                                    : null}
                                            </div>
                                        </TableCell>

                                    ) : null
                            )
                        ))
                    }
                    <TableCell className={classes.tableHeader} align="left">

                    </TableCell>
                    {
                        <TableCell className={classes.tableHeader} style={{ width: '10vw' }} align="left">
                            {this.renderPagination()}
                        </TableCell>

                    }
                </TableRow>
            </TableHead>
        )
    }

    getDocStatus = (row) => {
        const { hideStatus } = this.state;
        const { classes, theme } = this.props;
        const { user } = this.props.userStore;
        let temp = row.docStatus == 'AI_PENDING' ? 'Processing...' : (row.docStatus == 'REVIEW_PENDING' ? 'Review Pending' : 'Complete')
        return (
            !hideStatus ? (
                false ?
                    (
                        row.unsupportedDocFlag ?
                            <TableCell className={classes.inactiveTableData} style={{ pointerEvents: 'none', color: theme.palette.dullRed }} align="left">Unsupported Doc</TableCell>
                            :
                            <TableCell className={classes.templateNotFound} align="left">
                                <Tooltip title={user.userType === 'AGENT' ? "Contact your admin to setup a template for this document type." : "Click to setup a template for this document type."}>
                                    <NavLink style={{ color: theme.palette.dullRed }} to={{ pathname: user.userType === 'AGENT' ? `` : '/dashboard/templates' }} >
                                        Template not found
                            </NavLink>
                                </Tooltip>
                            </TableCell>
                    ) :
                    <TableCell className={this.getClassName(row)} style={{ pointerEvents: row.templateMappingFlag ? 'none' : 'auto' }} align="left">{temp}</TableCell>
            )
                : null
        )
    }

    getClassName = (row) => {
        const { classes } = this.props;
        //return row.docStatus == 'AI_PENDING' ? classes.inactiveTableData : `${classes.tableData}`
        return `${classes.tableData}`
        //  return row.docStatus == 'AI_PENDING' || !row.templateMappingFlag ? classes.inactiveTableData : `${classes.tableData}`
    }

    onFileClick = (e, file) => {
        if (file.aiErrorFlag) {
            e.preventDefault()
            this.props.commonStore.handleOpenSnackBar(file.aiErrorText, 'error')
        }
        else if (file.docStatus === "AI_PENDING")
            e.preventDefault()
    }

    getDocumentUrl(type, row) {
        this.props.documentStore.setProgress(true)
        if (type === 'finance')
            return `/document/finance/${row._id}`
        else
            return `/document/${row._id}`
    }


    render() {
        const { classes, filter } = this.props;
        const { inProgress, documentList, noMatchFound, downloadProgress } = this.props.dashboardStore;
        const { selectedDocs } = this.props.dashboardStore
        const { showPreview, currentDoc, searchText, hideStatus, noDocMessage, showInProgress, timeField } = this.state;
        const { activeTab } = this.props.commonStore;
        const { serverStatusProgress, user } = this.props.userStore
        const { financeDocs } = this.props.documentStore
        if (inProgress)
            return (
                <div style={{ height: '100%' }}>
                    <div className={classes.headerContainer}>
                        <Typography className={classes.docHeader}>{activeTab == 'ai pending' ? 'AI Pending' : this.props.heading}</Typography>
                        <Header searchType="docs" filter={this.props.filter}></Header>
                    </div>
                    <div><Loader height={100} width={100} color={this.props.theme.palette.blue} className={classes.loading} timeout={100000} /></div>
                </div>
            )
        return (
            <div style={{ height: '100%', overflowY: 'hidden' }}>
                <div className={classes.headerContainer}>
                    <Typography className={classes.docHeader}>{activeTab == 'ai pending' ? 'AI Pending' : this.props.heading}</Typography>
                    <Header searchType="docs" filter={this.props.filter}></Header>
                </div>
                {!noMatchFound && documentList.length > 0 ? <TableContainer style={{ height: '90%', backgroundColor: this.props.theme.palette.dark, overflowY: 'hidden' }} elevation={0} component={Paper}>
                    <Scrollbars>
                        <Table className={classes.table} aria-label="simple table">
                            {this.renderTableHead()}
                            <TableBody>
                                {documentList.map((row, index) => (
                                    <TableRow key={row._id} className={classes.tableRow}>
                                        <TableCell padding="checkbox" className={classes.checkbox}>
                                            <Checkbox
                                                key={row._id + "check"}
                                                disabled={row.docStatus == 'AI_PENDING'}
                                                onChange={(event, value) => this.onCheckboxChange(event, index, value)}
                                                checked={selectedDocs[index]}
                                                className={classes.checkbox}
                                                color="primary"
                                                inputProps={{
                                                    classes: {
                                                        root: classes.checkbox
                                                    }
                                                }}

                                            /></TableCell>
                                        <TableCell className={this.getClassName(row)} align="left"   >
                                            <div style={{ display: 'flex' }}>
                                                <div>
                                                    <ReactSVG
                                                        beforeInjection={svg => {
                                                            svg.classList.add(classes.docIcons)
                                                        }}
                                                        src={this.getDocumentIcon(row)} />
                                                </div>

                                                <div style={{ paddingTop: '10px', maxWidth: '15vw', textOverflow: 'ellipsis', overflow: 'hidden', whiteSpace: 'nowrap', paddingRight: '1vw' }} >
                                                    <Tooltip title={row.originalFileName}>
                                                        <NavLink onClick={(e) => this.onFileClick(e, row)} onMouseEnter={() => this.onMouseEnter(row)} onMouseLeave={() => this.onMouseLeave()} style={{ textDecoration: 'none', color: row.docStatus === "AI_PENDING" ? this.props.theme.palette.battleShipGray : 'white' }}
                                                            to={{
                                                                pathname:
                                                                    row.aiErrorFlag ? `` : (row.docStatus === "AI_PENDING" ? `` :
                                                                        (financeDocs.findIndex(x => x === row.docType) > -1 ? this.getDocumentUrl('finance', row) : this.getDocumentUrl('normal', row)))
                                                                , documentId: row._id, filter: this.props.filter
                                                            }} >
                                                            {row.originalFileName}
                                                        </NavLink>

                                                    </Tooltip>

                                                </div>
                                                {row.aiProcessStatus == 'FAILED' ? <Tooltip title="Processing failed"><ReactSVG className={classes.vertCenter} src={Images.error} /></Tooltip> : null}
                                            </div>
                                        </TableCell>
                                        {this.getDocStatus(row)}
                                        {activeTab === 'drafts' || activeTab === 'ai pending' ? <TableCell className={this.getClassName(row)} align="left">{row.assignedTo.userFullName}</TableCell> : null}
                                        {activeTab === 'reviewed' || activeTab === 'exported' ? <TableCell className={this.getClassName(row)} align="left">{row.reviewedBy && row.reviewedBy.userFullName}</TableCell> : null}
                                        {user.userType === 'SUPER_ADMIN' ? <TableCell className={this.getClassName(row)} align="left">{row.enterpriseId && row.enterpriseId.name}</TableCell> : null}
                                        <TableCell className={this.getClassName(row)} align="left">
                                            {Moment(row[`${timeField}`]).format('DD/MM/YYYY, h:mm a')}
                                        </TableCell>
                                        <TableCell className={this.getClassName(row)} align="left">
                                            <div className={classes.modified}>
                                                {row.sequence_no}
                                            </div>
                                            <div className={classes.options}>
                                                <DeleteForeverIcon className={classes.optionIcons} onClick={(event) => this.onDelete(row)} />&nbsp;
                                                {downloadProgress ?
                                                    <Loader height={20} width={20} color={this.props.theme.palette.white} /> :
                                                    <GetAppIcon className={classes.optionIcons} onClick={(event) => this.downloadDoc(row._id)} />}&nbsp;
                                                <ShareIcon className={classes.optionIcons} />
                                            </div>
                                        </TableCell>
                                        <TableCell style={{ width: '5.5vw' }} className={this.getClassName(row)} align="left">{row.aiErrorFlag ? 'Unsupported Doc' : (row.docType == undefined ? '---' : this.modifyText(row.docType === 'WRITERCORP' ? 'ATM_SLIP' : row.docType))}</TableCell>
                                        <TableCell className={this.getClassName(row)} align="right">
                                            <div style={{ display: 'flex', justifyContent: 'flex-end' }} >
                                                {row.comment &&
                                                    <LightTooltip title={row.comment} aria-label="add">
                                                        <ReactSVG style={{ marginRight: '1vw' }} src={row.docStatus == 'AI_PENDING' ? Images.inactiveMessage : Images.message} />
                                                    </LightTooltip>
                                                }
                                                {this.renderMenu(index, row)}
                                            </div>
                                        </TableCell>


                                    </TableRow>
                                ))}
                            </TableBody>
                        </Table>
                    </Scrollbars>
                </TableContainer> :
                    (!noMatchFound ? this.renderNotFoundMessage(noDocMessage) : null)

                }

                {noMatchFound ? this.renderNotFoundMessage("No matching documents found!") : null}

                {this.renderSupportingComponents()}
            </div>
        );
    }
}

export default withStyles(dashboardStyles, { withTheme: true })(withRouter(DocumentList));
